import React from "react";
import Modal from '../../component/Inc/Modal';
function PopSuspension(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="com_input">
      <h2 className='pop_tit'>중단 우려회원 등록</h2>
      <div className="content_container scroll">
        <section className='search search_top'>
          <input type="search" placeholder='학생명 검색' className="input xs type_search" />
          <button className="com_btn gray ws xs icon_search"></button>
        </section>
        <span className="com_btn btn_notice full xs">홍길동202</span>
        <hr className="com_divider" />
        <ul className='com_input_sec'>
          <li className='input_field'>
            <select className="select">
              <option value="수업 선택">수업 선택</option>
            </select>
          </li>
          <li className='tit_field'>제목</li>
          <li className="input_field">
            <input type="text" className="input" placeholder="제목" />
          </li>
          <li className='tit_field'>입사일자 선택</li>
          <li className='input_field'>
            <textarea className="textarea" placeholder="내용 입력 (500자)"></textarea>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopSuspension;